import { LabMDM } from "./lab";

//This model is used to define the lab printer properties
export class Template {
    id: string;

    /** The lab associated with the entity of the template. */
    lab:LabMDM;

	/** The Name of the template. */
    templateName:string ;

	/** Entity associated with the template. */
    entity:string;

    /** Height of the label. */
    height:number;

    /** Width of the label. */
    width:number;

    /** Format of the Template. */
    format:string;

    regex:string;
    
    receptionRegex : boolean;

    printPage : boolean;

    batchRegex : boolean;

    lastPrintedValue : string;

    active:boolean;

}
